/**
 * Generated by orval v8.11.0 🍺
 * Do not edit manually.
 * Core API
 * Core API Documentation
 * OpenAPI spec version: 1.0
 */

/**
 * Organisation plan tier (platform admin only)
 */
export enum UpdateOrganisationDtoPlan {
  LAUNCH = "LAUNCH",
  BOOST = "BOOST",
  SCALE = "SCALE",
}
